module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/trading-1bcf33a98abbf485ab81b5c66e390943.png";